// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.1@core-js/modules/es7.map.of.js
// module id = 307
// module chunks = 0